export default "__VITE_ASSET__ccF$LD8b__"